module.exports = __webpack_public_path__ + "img/8-onebg.96e5ac03.jpg";